module.exports = __webpack_public_path__ + "befb5ecd54a4bddd58c5e324de178673.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/head/wasistgoldencity5.jpg
// module id = 787
// module chunks = 0